import React, { Component } from "react";
import {
  Card,
  Row,
  Col,
  Spin,
  Tooltip,
  Modal as modal,
  Space as space,
  Button as button,
} from "antd";
import Config from "../../../config";
import PaymentDetails from "./PaymentDetails";
import ClaimsDetail from "./ClaimsDetail";
import ProviderDetails from "./ProvidersDetail";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import DocModal from "./DocModal/DocModal";
import "./ClaimsDetail.css";
import MoopHistory from "./MoopHistory/MoopHistory";
import Edits from "./Edits/Edits";
import CreateTicket from "./../../TicketManagement/CreateTicket/CreateTicket";
import PrimaryButton from "../../CommonComponent/Buttons/PrimayButton"

import moment from "moment";
import ClaimNotesTab from "./ClaimNotesTab";
// const { createRoot } = ReactDOM;
// const {  Button, Modal, Space  } = antd;

export default class ClaimDetailsHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
    //  CreatedForId: "this.props.data.claimNumber",
      Fromwhere: "Claims",
      TicketShow: false,
      apiError: false,
      EOP: [],
      memberinfo: true,
      loader: true,
      activetab: 0,
      id: 0,
      memberDetails: [],
      memberInfo: [],
      Message: "",
      claimSummary: {},
      providerInformation: {},
      serviceInformation: {},
      memberInformation: {},
      componentKey: 1,
      paymentInformtaions: {},
      icdCodes: [],
      notesTabData: [],
      adjustmentDetails: [],
      letters: [],
      moopInformation: [],
    };
  }
  TicketShowInfo = () => {
    this.setState((state) => ({ TicketShow: true }));
  };
  TicketHideInfo = () => {
    this.setState((state) => ({ TicketShow: false }));
  };
  getmemberShipInfo = (value) => {
    console.log("vv",value)
    this.setState({
      memberinfo: true,
      activetab: value,
    });
  };

  getFormType = (no, val) => {
    let type = "";
    let catergory = "";
    switch (no[0]) {
      case "P":
        type = "CMS 1500";
        catergory = "Professional";
        break;
      case "I":
        type = "CMS 1450";
        catergory = "Institutional";
        break;
      default:
        type = "J430D";
        catergory = "Dental";
    }
    return val === "form_type" ? type : catergory;
  };

  componentDidMount() {
    this.setState({ loader: true });
    const headers = { Authorization: sessionStorage.getItem("access_token") };
    // Api for member details card section. loading the responce in memberDetails array....
    const uniqueMemberID =
      this.props.fromPage === "Claims Search"
        ? this.props.data.uniqueMemberID
        : this.props.data.UniqueMemberID;
    const planCode =
      this.props.fromPage === "Claims Search"
        ? this.props.data.planCode
        : this.props.data.PlanCode;
    fetch(
      `${Config.api}/GetClaimDeatilsBasedOnClaim?Claimno=${
        this.props.data.claimNumber
      }&Planname=${sessionStorage.getItem("planName")}&ClaimStatus=${
        this.props.data.claimStatus
      }`,
      { headers }
    )
      .then((res) => res.json())
      .then((res) => {
        console.log("res",res)
         //res.memberInformation= null
        if(res.memberInformation == null ){
          this.setState({
            loader: false,
            apiError: true,
          });
        }else{
        //let data = res.ClaimsDetails;
        if (res) {
          this.setState({
            claimSummary: res.claimSummaryDetails.claimSummary[0],
            providerInformation: res.providerInformation[0],
            serviceInformation: res.serviceInformation,
            memberInformation: res.memberInformation[0],
            moopInformation: res.moopInformation,
            edits: res.edits,
            paymentInformtaions: res.paymentInformtaions[0],
            icdCodes: res.claimSummaryDetails.icdCodes,
            adjustmentDetails: res.serviceInformation.adjustmentDetails,
            loader: false,
            notesTabData: res.notes,
            apiError: false,
            letters: res.letters,
          });
        } else {
          this.setState({
            loader: false,
            apiError: true,
          });
        }
      }
      });
  }

  render() {
    console.log("ee",this.state.edits)
    const TicketHideInfo = () => {
      this.setState((state) => ({ TicketShow: false }));
    };
    const warning = () => {
      modal.confirm({
        title: "Are you sure to cancel",
        content: "cancel will discard all the added data",
        onOk() {
          TicketHideInfo();
        },
        okText: "Yes, Cancel",
        cancelText: "No",
      });
    };
    const CancelButton = () => (
      <space wrap>
        <button
          style={{
            display: "inline-block",
            align: "right",
            verticalAlign: "middle",
            marginTop: "-34px",
          }}
          className="details-tab p-1 pl-2 pr-2"
          onClick={warning}
        >
          Cancel
        </button>
      </space>
    );

    const EOP = this.state.EOP;
    const claimSummary = this.state.claimSummary;
    const memberInformation = this.state.memberInformation;
    const providerInformation = this.state.providerInformation;
    const paymentInformtaions = this.state.paymentInformtaions;
    return (
      <div
        className="mx-2"
        // style={{ position: "fixed", width: "99vw" }}
      >
        {!this.state.loader && !this.state.apiError && (
          <div>
            <div className="details-header-sub ml-2 mb-1">Claim Summary</div>
            {/* {!this.state.TicketShow && sessionStorage.getItem("planName") !== "csh" && (
              <div className="complaint-button">
                <button
                  style={{
                    display: "inline-block",
                    align: "right",
                    verticalAlign: "middle",
                    marginTop: "-34px",
                  }}
                  className="details-tab p-1 pl-2 pr-2"
                  onClick={() => this.TicketShowInfo()}
                >
                  
                  Create a Ticket
                </button>
              </div>
            )} */}
            <Card className="pr-2 pb-2 mb-2 detail-header">
              <Row>
                <Col span={19}>
                  <Row
                    className="pb-1"
                    style={{
                      borderLeft: "3px solid #4683ED",
                      borderRadius: "4px",
                      height: "7vh",
                    }}
                  >
                    <Col span={20} className="p-2">
                      <span className="member-name">
                        {claimSummary.claimType}{" "}
                        {claimSummary.claimNumber
                          ? this.getFormType(
                              claimSummary.claimNumber,
                              "category"
                            )
                          : ""}
                      </span>
                      <span className="font-12" style={{ color: "black" }}>
                        <b>
                          {" "}
                          {claimSummary.isClean === "True"
                            ? "(Clean Claim)"
                            : "(Unclean Claim)"}
                        </b>
                      </span>
                    </Col>
                    <Col span={4} className="mt-1 mb-1">
                      <div className="details-mbi details-header-sub">
                        Patient ID{" "}
                        <div className="claims-text-data">
                          {memberInformation.insuredUniqueNumber
                            ? memberInformation.insuredUniqueNumber
                            : "---"}
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <div className="pt-1">
                    <div className="border-horizental ml-1 mt-2"></div>
                  </div>
                  <Row className="mt-4 mx-3">
                    {claimSummary.claimNumber &&
                    claimSummary.claimNumber[0] === "I" ? (
                      <Col span={5} className="claims-details pr-1">
                        Rendering Provider:
                        <div className="claims-details-text">
                          {providerInformation.renderingProviderFirstName
                            ? providerInformation.renderingProviderFirstName
                            : "---"}
                        </div>
                      </Col>
                    ) : (
                      <Col span={5} className="claims-details pr-1">
                        Billing Provider:
                        <div className="claims-details-text">
                          {providerInformation.billingProviderName
                            ? providerInformation.billingProviderName
                            : "---"}
                        </div>
                      </Col>
                    )}
                    <Col span={4} className="claims-details pr-1">
                      Age:{" "}
                      <div className="claims-details-text">
                        {claimSummary.age ? claimSummary.age + " days" : "---"}
                      </div>
                    </Col>
                    {claimSummary.claimNumber &&
                    claimSummary.claimNumber[0] === "I" ? (
                      <Col span={5} className="claims-details pr-1">
                        Attending Provider:{" "}
                        <div className="claims-details-text">
                          {providerInformation.attendingProviderFirstName
                            ? providerInformation.attendingProviderFirstName
                            : "---"}
                        </div>
                      </Col>
                    ) : claimSummary.claimNumber &&
                      claimSummary.claimNumber[0] === "P" ? (
                      <Col span={5} className="claims-details pr-1">
                        PCP Name:{" "}
                        <div className="claims-details-text">
                          {claimSummary.pcpName ? claimSummary.pcpName : "---"}
                        </div>
                      </Col>
                    ) : (
                      <Col span={5} className="claims-details pr-1">
                        Rendering Provider:{" "}
                        <div className="claims-details-text">
                          {providerInformation.renderingProviderFirstName
                            ? providerInformation.renderingProviderFirstName
                            : "---"}
                        </div>
                      </Col>
                    )}
                    <Col span={5} className="claims-details pr-1">
                      Tax ID:
                      <div className="claims-details-text">
                        {providerInformation.taxID
                          ? providerInformation.taxID
                          : "---"}
                      </div>
                    </Col>
                    <Col span={5} className="claims-details pr-1">
                      {claimSummary.claimNumber &&
                      claimSummary.claimNumber[0] === "I"
                        ? "Statement Cover Period"
                        : "D.O.S. From - D.O.S."}
                      <div className="claims-details-text">
                        {moment(new Date(claimSummary.dosFromDate)).format(
                          "ll"
                        )}{" "}
                        -{" "}
                        {moment(new Date(claimSummary.dosToDate)).format("ll")}
                      </div>
                    </Col>
                  </Row>

                  {/* Second Row */}

                  <Row className="mt-4 mx-3 pt-2">
                    <Col span={5} className="claims-details pr-1">
                      PBP:{" "}
                      <div className="claims-details-text">
                        {claimSummary.pbp ? claimSummary.pbp : "---"}
                      </div>
                    </Col>
                    {claimSummary.claimNumber &&
                    claimSummary.claimNumber[0] === "I" ? (
                      <Col span={5} className="claims-details pr-1">
                        Services Location:{" "}
                        <div className="claims-details-text">
                          {claimSummary.billClassification || claimSummary.pos
                            ? claimSummary.billClassification +
                              " " +
                              claimSummary.pos
                            : "---"}
                        </div>
                      </Col>
                    ) : (
                      <Col span={4} className="claims-details pr-1">
                        P.O.S:{" "}
                        <div className="claims-details-text">
                          {claimSummary.pos ? claimSummary.pos : "---"}
                        </div>
                      </Col>
                    )}

                    {claimSummary.claimNumber &&
                    claimSummary.claimNumber[0] === "I" ? (
                      <Col span={5} className="claims-details pr-1">
                        Bill Type:{" "}
                        <div className="claims-details-text">
                          {claimSummary.billType
                            ? claimSummary.billType
                            : "---"}
                        </div>
                      </Col>
                    ) : claimSummary.claimNumber &&
                      claimSummary.claimNumber[0] === "P" ? (
                      <Col span={5} className="claims-details pr-1">
                        Patient Control No:{" "}
                        <div className="claims-details-text">
                          {claimSummary.prePatientCtrlNo
                            ? claimSummary.prePatientCtrlNo
                            : "---"}
                        </div>
                      </Col>
                    ) : (
                      <Col span={5} className="claims-details pr-1">
                        Missing Teeth:{" "}
                        <div className="claims-details-text ellipsisText">
                          <EllipsisWithTooltip>
                            {claimSummary.missingTeethInfo
                              ? claimSummary.missingTeethInfo
                              : "---"}
                          </EllipsisWithTooltip>
                          {/* <Tooltip title={claimSummary.missingTeethInfo} placement="topLeft" align="left">
                          {claimSummary.missingTeethInfo ? claimSummary.missingTeethInfo : "---"}
                        </Tooltip> */}
                        </div>
                      </Col>
                    )}
                    <Col span={5} className="claims-details pr-1">
                      E.O.P.
                      <DocModal type="EOP" DocList={this.state.letters} />
                    </Col>
                  </Row>
                </Col>
                <Col span={5}>
                  <Row className="pl-1 pr-3 pt-2">
                    <div className="claims-border-vertical pl-2">
                      <Col span={24} className="mb-1">
                        <span className="claims-details">Received Date:</span>
                        <span className="claims-details-text ml-1">
                          {claimSummary.receivedDate
                            ? moment(
                                new Date(claimSummary.receivedDate)
                              ).format("ll")
                            : "---"}
                        </span>
                      </Col>
                      <Col span={24} className="mb-1">
                        <span className="claims-details">Billed Amount:</span>
                        <span className="claims-details-text ml-1">
                          {claimSummary.billedAmount
                            ? "$ " +
                              parseFloat(claimSummary.billedAmount).toFixed(2)
                            : "$ 0.00"}
                        </span>
                      </Col>
                      {/* <Col span={24} className="mb-1">
                      <span className="claims-details">State:</span>
                      <span className="claims-details-text ml-1">{claimSummary.claimFormStatusCode}</span>
                    </Col> */}
                      <Col span={24} className="mb-1">
                        <span className="claims-details">Status:</span>
                        <span className="claims-details-text ml-1">
                          {claimSummary.claimStatus}
                        </span>
                      </Col>
                      <Col span={24} className="mb-1">
                        <span className="claims-details">State:</span>
                        <span className="claims-details-text ml-1">
                          {claimSummary?.claimformstatuscode || "----"}
                        </span>
                      </Col>

                      <Col span={24} className="mb-1">
                        <span className="claims-details">Form Type:</span>
                        <span className="claims-details-text ml-1">
                          {claimSummary.formType
                            ? claimSummary.formType
                            : "---"}
                        </span>
                      </Col>

                      <Col span={24} className="mb-1">
                        <span className="claims-details">Claim Type:</span>
                        <span className="claims-details-text ml-1">
                          {claimSummary.claimType}{" "}
                          {claimSummary.claimSource
                            ? " (" + claimSummary.claimSource + ")"
                            : ""}
                        </span>
                      </Col>

                      <Col span={24} className="mb-1">
                      <span className="claims-details">Claim Submission:</span>
                      <span className="claims-details-text ml-1">
                      {claimSummary.claimSubmission ? claimSummary.claimSubmission : "---"}
                      </span>
                    </Col>

                      <Col span={24} className="">
                        <span className="claims-details">Moop Amount:</span>
                        <span className="claims-details-text ml-1">
                          {paymentInformtaions.moopAmount
                            ? " $ " + paymentInformtaions.moopAmount
                            : "$ 0.00"}
                        </span>
                      </Col>
                    </div>
                  </Row>
                </Col>
              </Row>
            </Card>
            {this.state.TicketShow && (
              <div>
                <div className="ticket-header">Create Ticket</div>
              </div>
            )}

            <div>
              {this.state.TicketShow && (
                <div>
                  <CreateTicket TicketHideInfo={this.TicketHideInfo} Fromwhere={this.state.Fromwhere}
                  TicketCreatedForIDProps={this.props.data.claimNumber} TicketCreatedForProps={this.state.memberInformation.patientName}/>
                </div>
              )}
            </div>

            {/* Body Of member Details Page */}
            <div className="pt-1 pb-1">
              <Card className="button-area pr-2">
                <Row justify="space-between">
                  <Col span={3}>
                  <PrimaryButton  className={this.state.activetab == 0 ? "details-tab py-1 px-4" : "simple-button px-4 profileTabs"} onClick={() => this.getmemberShipInfo(0)} label={"Service & Payment Details"} />
                    {/* <PrimaryButton 
                      onClick={() => this.getmemberShipInfo(0)}
                      className={
                        this.state.activetab == 0
                          ? "details-tab py-1 px-5"
                          : "simple-button px-5 profileTabs"
                      } 
                      label={"Service & Payment Details"} /> */}
                      
                    {/* </PrimaryButton> */}
                  </Col>
                  {/* Clicla */}
                  <Col span={2}>
                  <PrimaryButton  className={this.state.activetab == 1 ? "details-tab py-1 px-5" : "simple-button px-5 profileTabs"} onClick={() => this.getmemberShipInfo(1)} label={"Claims Details"} />
                    {/* <button
                      onClick={() => this.getmemberShipInfo(1)}
                      className={
                        this.state.activetab == 1
                          ? "details-tab py-1 px-5"
                          : "simple-button px-5 profileTabs"
                      }
                    >
                      Claims Details
                    </button> */}
                  </Col>

                  <Col span={3}>
                  <PrimaryButton  className={this.state.activetab == 2 ? "details-tab py-1 px-5" : "simple-button px-5 profileTabs"} onClick={() => this.getmemberShipInfo(2)} label={"Provider Details"} />
                    {/* <button
                      onClick={() => this.getmemberShipInfo(2)}
                      className={
                        this.state.activetab == 2
                          ? "details-tab py-1 px-5"
                          : "simple-button px-5 profileTabs"
                      }
                    >
                      Provider Details
                    </button> */}
                  </Col>
                  {sessionStorage.getItem("planName") !== "secur" && (
                  <Col span={2}>
                  <PrimaryButton  className={this.state.activetab == 3 ? "details-tab py-1 px-5" : "simple-button px-5 profileTabs"} onClick={() => this.getmemberShipInfo(3)} label={"Notes"} />
                    {/* <button
                      onClick={() => this.getmemberShipInfo(3)}
                      className={
                        this.state.activetab == 3
                          ? "details-tab py-1 px-5"
                          : "simple-button px-5 profileTabs"
                      }
                    >
                      Notes
                    </button> */}
                  </Col>
                  )}
                  <Col span={2}>
                  <PrimaryButton  className={this.state.activetab == 5 ? "details-tab py-1 px-5" : "simple-button px-5 profileTabs"} onClick={() => this.getmemberShipInfo(5)} label={"Edits"} />
                    {/* <button
                      onClick={() => this.getmemberShipInfo(4)}
                      className={
                        this.state.activetab == 4
                          ? "details-tab py-1 px-5"
                          : "simple-button px-5 profileTabs"
                      }
                    >
                      Moop History
                    </button> */}
                  </Col>

                  <Col span={3}>
                  <PrimaryButton  className={this.state.activetab == 4 ? "details-tab py-1 px-4" : "simple-button px-4 profileTabs"} onClick={() => this.getmemberShipInfo(4)} label={"Moop History"} />
                    {/* <button
                      onClick={() => this.getmemberShipInfo(4)}
                      className={
                        this.state.activetab == 4
                          ? "details-tab py-1 px-5"
                          : "simple-button px-5 profileTabs"
                      }
                    >
                      Moop History
                    </button> */}
                  </Col>
                </Row>
              </Card>
            </div>
            {/* Leading Components based on Button clicked */}
            <div className="py-3">
              {this.state.activetab === 0 ? (
                <PaymentDetails
                  claimSummary={this.state.claimSummary}
                  serviceInformation={this.state.serviceInformation}
                  paymentInformtaions={this.state.paymentInformtaions}
                  icdCodes={this.state.icdCodes}
                  adjustmentDetails={this.state.adjustmentDetails}
                />
              ) : this.state.activetab === 1 ? (
                <ClaimsDetail
                  paymentInformtaions={this.state.paymentInformtaions}
                  memberInformation={this.state.memberInformation}
                />
              ) : this.state.activetab === 2 ? (
                <ProviderDetails
                  providerInformation={this.state.providerInformation}
                  claimSummary={this.state.claimSummary}
                />
              ) : this.state.activetab === 4 ? (
                <MoopHistory moopInformation={this.state.moopInformation} />
              ) : this.state.activetab === 5 ? (
                <Edits edits={this.state.edits} />
              ) : (
                <ClaimNotesTab notesData={this.state.notesTabData} />
              )}
            </div>
          </div>
        )}

        {this.state.loader && !this.state.apiError && (
          <Row
            style={{ marginTop: "35vh" }}
            justify="center"
            align="center"
            type="flex"
          >
            <Col style={{ textAlign: "center" }}>
              <Spin size="large" />
              <div className="search-sreen-text">Loading Data...</div>
            </Col>
          </Row>
        )}

        {this.state.apiError && (
          <Row
            style={{ marginTop: "35vh" }}
            justify="center"
            align="center"
            type="flex"
          >
            <Col style={{ textAlign: "center" }}>
              <div className="search-sreen-text">No Claim Details Found!</div>
            </Col>
          </Row>
        )}
      </div>
    );
  }
}